import { Route } from '@angular/router';
//import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/zdslogic-ui-shell/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';

//zdslogic components
//import { AboutComponent } from './zdslogic-ui-plugins/about/about.component';

//import { CollaborationContainerComponent } from './zdslogic-ui-plugins/collaboration/collaboration-container/collaboration-container.component';
//import { WikiTopicListComponent } from './zdslogic-ui-plugins/wiki/wiki-topic-list/wiki-topic-list.component';
import { VideoJitsiPublicComponent } from './zdslogic-ui-plugins/collaboration/collaboration-video-public/video-jitsi-public.component';
//import { ContactsLayoutComponent } from './zdslogic-ui-plugins/contacts/contacts-layout/contacts-layout.component';
//import { TeamsAboutComponent } from './zdslogic-ui-plugins/teams/about/about.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

	// Redirect empty path to '/home'
	{ path: '', pathMatch: 'full', redirectTo: 'home' },

	// Redirect signed in user to the '/dashboards/project'
	//
	// After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
	// path. Below is another redirection for that path to redirect the user to the desired
	// location. This is a small convenience to keep all main routes together here on this file.
	{ path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'home' },

	// Landing routes
	{
		path: '',
		component: LayoutComponent,
		children: [
			{ path: '', loadChildren: () => import('app/zdslogic-ui-shell/modules/landing/home/home.module').then(m => m.LandingHomeModule) },
			{ path: 'home', loadChildren: () => import('app/zdslogic-ui-shell/modules/landing/home/home.module').then(m => m.LandingHomeModule) },
	        { path: 'about', loadChildren: () => import('app/zdslogic-ui-plugins/about/about.module').then(m => m.AboutModule) },
	        { path: 'ai', loadChildren: () => import('app/zdslogic-ui-plugins/ai/ai.module').then(m => m.AIModule) },
	        { path: 'auto', loadChildren: () => import('app/zdslogic-ui-plugins/auto/auto.module').then(m => m.AutoModule) },
	        { path: 'bylaws', loadChildren: () => import('app/zdslogic-ui-plugins/bylaws/bylaws.module').then(m => m.BylawsModule) },
	        { path: 'donate', loadChildren: () => import('app/zdslogic-ui-plugins/donate/donate.module').then(m => m.DonateModule) },
	        { path: 'mission', loadChildren: () => import('app/zdslogic-ui-plugins/mission/mission.module').then(m => m.MissionModule) },
	        { path: 'revenue', loadChildren: () => import('app/zdslogic-ui-plugins/revenue/revenue.module').then(m => m.RevenueModule) },
	        { path: 'expenses', loadChildren: () => import('app/zdslogic-ui-plugins/expenses/expenses.module').then(m => m.ExpensesModule) },
	        { path: 'smarthome', loadChildren: () => import('app/zdslogic-ui-plugins/smarthome/smarthome.module').then(m => m.SmartHomeModule) },
	        { path: 'profiles', loadChildren: () => import('./zdslogic-ui-plugins/profiles/profiles.module').then(m => m.ProfilesModule) },
	        { path: 'jobs', loadChildren: () => import('./zdslogic-ui-plugins/jobs/jobs.module').then(m => m.JobsModule) },
	        { path: 'resumes', loadChildren: () => import('./zdslogic-ui-plugins/resumes/resumes.module').then(m => m.ResumesModule) },
	        { path: 'teams', loadChildren: () => import('./zdslogic-ui-plugins/teams/teams.module').then(m => m.TeamsModule) },			
	        { path: 'training', loadChildren: () => import('./zdslogic-ui-plugins/training/trainings.module').then(m => m.TrainingsModule) },
			{
				path: 'articles',
				loadChildren: () => import('./zdslogic-ui-plugins/articles/articles.module').then(m => m.ArticlesModule)
			},
			{
				path: 'blog',
				loadChildren: () => import('./zdslogic-ui-plugins/articles/articles.module').then(m => m.ArticlesModule)
			},
			{
				path: 'cafe',
				loadChildren: () => import('./zdslogic-ui-plugins/cafe/cafe.module').then(m => m.CafeModule)
			},
			{
				path: 'dash',
				loadChildren: () => import('./zdslogic-ui-plugins/dash/dash.module').then(m => m.DashModule)
			},
			{
				path: 'blog',
				loadChildren: () => import('./zdslogic-ui-plugins/articles/articles.module').then(m => m.ArticlesModule)
			},

			{
				path: 'books',
				loadChildren: () => import('./zdslogic-ui-plugins/books/books-shop-site/books-shop-site.module').then(m => m.BooksShopSiteModule)
			},
			{
				path: 'books-admin',
				loadChildren: () => import('./zdslogic-ui-plugins/books/books-admin/books-admin.module').then(m => m.BooksAdminModule)
			},
			{
				path: 'contact',
				loadChildren: () => import('./zdslogic-ui-plugins/collaboration/collaboration.module').then(m => m.CollaborationModule)
			},

			{
				path: 'games',
				loadChildren: () => import('./zdslogic-ui-plugins/games/games.module').then(m => m.GamesModule)
			},
/*
			{
				path: 'collaboration',
				loadChildren: () => import('./zdslogic-ui-plugins/collaboration/collaboration.module').then(m => m.CollaborationModule)
			},
			{
				path: 'meet', component: VideoJitsiPublicComponent
			},
			{
				path: 'teams/about',
				component: TeamsAboutComponent
			},
*/
			{
				path: 'shop',
				loadChildren: () => import('./zdslogic-ui-plugins/shop/shop-site/shop-site.module').then(m => m.ShopSiteModule)
			},

			{
				path: 'topics',
				loadChildren: () => import('./zdslogic-ui-plugins/wiki/wiki.module').then(m => m.WikiModule)
			},
/*
			{
				path: 'projects',
				loadChildren: () => import('./zdslogic-ui-plugins/projects/projects.module').then(m => m.ProjectsModule)
			},
			{
				path: 'my-emails',
				loadChildren: () => import('./zdslogic-ui-plugins/emails/my-emails/my-emails.module').then(m => m.MyEMailsModule)
			},
*/
			{
				path: 'map',
				loadChildren: () => import('./zdslogic-ui-plugins/map/map.module').then(m => m.MapModule)
			},

			{
				path: 'logs',
				loadChildren: () => import('./zdslogic-ui-plugins/logs/logs.module').then(m => m.LogsModule)
			},

			{
				path: 'whois',
				loadChildren: () => import('./zdslogic-ui-plugins/whois/whois.module').then(m => m.WhoisModule)
			},
			{
				path: 'weather',
				loadChildren: () => import('./zdslogic-ui-plugins/weather/weather.module').then(m => m.WeatherModule)
			},
/*
			{
				path: 'visualizations',
				loadChildren: () => import('./zdslogic-ui-plugins/visualizations/visualizations.module').then(m => m.VisualizationsModule)
			},
*/
			{ path: 'meet', component: VideoJitsiPublicComponent },
/*
			{ path: 'confirmation-required', loadChildren: () => import('app/zdslogic-ui-shell/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule) },
			{ path: 'forgot-password', loadChildren: () => import('app/zdslogic-ui-shell/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule) },
			{ path: 'reset-password', loadChildren: () => import('app/zdslogic-ui-shell/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule) },
			{ path: 'sign-in', loadChildren: () => import('app/zdslogic-ui-shell/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule) },
			{ path: 'sign-up', loadChildren: () => import('app/zdslogic-ui-base/registration/registration.routing/registration-routing.module').then(m => m.RegistrationRoutingModule) },
*/
		]
	},

	// Auth routes for authenticated users
	{
		path: '',
		//canActivate: [AuthGuard],
		//canActivateChild: [AuthGuard],
		component: LayoutComponent,
		data: {
			layout: 'empty'
		},
		children: [
			{ path: 'sign-out', loadChildren: () => import('app/zdslogic-ui-shell/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule) },
			{ path: 'unlock-session', loadChildren: () => import('app/zdslogic-ui-shell/modules/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule) },
/*
			{
				path: 'contacts',
				component: ContactsLayoutComponent,
				loadChildren: () => import('./zdslogic-ui-plugins/contacts/routing/contacts-routing.module').then(m => m.ContactsRoutingModule)
			},
			{
				path: 'teams',
				loadChildren: () => import('./zdslogic-ui-plugins/teams/teams.module').then(m => m.TeamsModule)
			},

			{
				path: 'calendar',
				loadChildren: () => import('./zdslogic-ui-plugins/calendar/calendar.module').then(m => m.CalendarViewModule)
			},

			{
				path: 'apikeys',
				loadChildren: () => import('./zdslogic-ui-plugins/apikeys/apikey.module').then(m => m.ApiKeyModule)
			},

			{
				path: 'inventory',
				loadChildren: () => import('./zdslogic-ui-plugins/inventory/inventory.module').then(m => m.InventoryModule)
			},

			{
				path: 'subscriptions',
				loadChildren: () => import('./zdslogic-ui-plugins/subscriptions/subscriptions.module').then(m => m.SubscriptionsModule)
			},

			{
				path: 'users',
				loadChildren: () => import('./zdslogic-ui-base/users/users.module').then(m => m.UsersModule)
			},

			{
				path: 'my-files',
				loadChildren: () => import('./zdslogic-ui-plugins/system/my-files/myfiles.module').then(m => m.MyFilesModule)
			},
			{
				path: 'user-files',
				loadChildren: () => import('./zdslogic-ui-plugins/system/user-files/files.module').then(m => m.FilesModule)
			},
			{
				path: 'system',
				loadChildren: () => import('./zdslogic-ui-plugins/system/system-routing/system-routing.module').then(m => m.SystemRoutingModule)
			},
*/
		]
	},

	// Admin routes
	{
		path: '',
		//canActivate: [AuthGuard],
		//canActivateChild: [AuthGuard],
		component: LayoutComponent,
		resolve: {
			initialData: InitialDataResolver,
		},
		children: [
			{
				path: 'pages', children: [
					{ path: 'coming-soon', loadChildren: () => import('app/zdslogic-ui-shell/modules/admin/pages/coming-soon/coming-soon.module').then(m => m.ComingSoonModule) },
					{
						path: 'error', children: [
							{ path: '404', loadChildren: () => import('app/zdslogic-ui-shell/modules/admin/pages/error/error-404/error-404.module').then(m => m.Error404Module) },
							{ path: '500', loadChildren: () => import('app/zdslogic-ui-shell/modules/admin/pages/error/error-500/error-500.module').then(m => m.Error500Module) }
						]
					},
					// Maintenance
					{ path: 'maintenance', loadChildren: () => import('app/zdslogic-ui-shell/modules/admin/pages/maintenance/maintenance.module').then(m => m.MaintenanceModule) }
				]
			},
			// 404 & Catch all
			{ path: '404-not-found', pathMatch: 'full', loadChildren: () => import('app/zdslogic-ui-shell/modules/admin/pages/error/error-404/error-404.module').then(m => m.Error404Module) },
			{ path: '**', redirectTo: '404-not-found' },

		]
	}
];
